import * as React from "react";

import SLSelect from "./SLSelect";

export interface SelectItem {
  displayString: string;
  value: string;
}

interface IProps {
  className?: string;
  items: SelectItem[];
  onItemSelected: (item: SelectItem) => void;
  selectedItem?: SelectItem;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
  renderLabel?: (displayString: string) => React.ReactElement<any>;
  fullWidth?: boolean;
}

interface IState {
  isOpen: boolean;
}

export default class SLSelectContainer extends React.Component<IProps, IState> {
  public static defaultProps: Partial<IProps> = {
    fullWidth: true
  };

  public state: IState = {
    isOpen: false
  };

  public render() {
    const {
      className,
      items,
      selectedItem,
      disabled,
      label,
      placeholder,
      renderLabel,
      fullWidth
    } = this.props;
    const { isOpen } = this.state;

    return (
      <SLSelect
        isOpen={isOpen}
        className={className}
        disabled={disabled}
        onOpen={this.onOpen}
        onClose={this.onClose}
        items={items}
        label={label}
        renderLabel={renderLabel}
        placeholder={placeholder}
        selectedItem={selectedItem}
        onItemSelected={this.onItemSelected}
        fullWidth={fullWidth!}
      />
    );
  }

  private onOpen = () => {
    this.setState({ isOpen: true });
  };

  private onClose = () => {
    this.setState({ isOpen: false });
  };

  private onItemSelected = (item: SelectItem) => {
    const { onItemSelected } = this.props;
    onItemSelected(item);
    this.onClose();
  };
}



// WEBPACK FOOTER //
// ./src/components/SLSelect/SLSelectContainer.tsx